import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2, AlertCircle } from "lucide-react";
import { Layout } from "../components/Layout";
import { ReadingView } from "../components/ReadingView";
import { StepShell } from "../components/Section";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SharedReading() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await axios.get(`${API}/reading/${id}`);
        if (active) setData(res.data);
      } catch (e) {
        if (active) setError(true);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
    // id is the only reactive input; axios/API are stable module references.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <Layout>
      {loading && (
        <StepShell>
          <div className="flex flex-col items-center gap-3 text-[#6b4f12] py-16">
            <Loader2 size={34} className="aura-spin text-[#D4AF37]" />
            <span className="serif text-lg">Analyse wird geladen...</span>
          </div>
        </StepShell>
      )}

      {!loading && error && (
        <StepShell>
          <div className="flex flex-col items-center gap-4 text-center py-16">
            <AlertCircle size={40} className="text-[#b8860b]" />
            <p className="serif text-xl text-[#4C1D95]">Diese Analyse wurde nicht gefunden.</p>
            <button
              data-testid="shared-new-btn"
              onClick={() => navigate("/")}
              className="serif text-lg px-8 py-3 rounded-full bg-gradient-to-r from-[#F0C548] to-[#B8860B] text-white glow-soft hover:glow-strong transition-all duration-300"
            >
              Eigene Analyse starten
            </button>
          </div>
        </StepShell>
      )}

      {!loading && data && (
        <ReadingView
          result={data}
          cards={data.drawnCards.map((c, i) => ({ id: `${i}-${c.name}`, name: c.name, img: c.image }))}
          positions={data.drawnCards.map((c) => c.position)}
          meta={{ topicLabel: data.topicLabel, spreadLabel: data.spreadLabel }}
          onRestart={() => navigate("/")}
          restartLabel="Eigene Analyse starten"
        />
      )}
    </Layout>
  );
}
